// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__giSii","large":"styles_large__1AzBX"};